/* eslint-disable */ 
import { omit } from 'lodash'
import * as R from 'ramda'

export function handleControl (props, objValue, option) {
  // console.log('handleControl', props, eventConfig)
  const {
    query, path,// 组件 数据源
    clearKey, killPending, reduxObj, requestType,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  // ---- 数据处理 -----
  let formatQuery = R.mergeLeft(objValue, {
    ...query,
    ...reduxObj,
    refQ: false,
    pageNumber: 1,
    killPending
  })
  const formatClearKey = (clearKey || '').split(',')
  // ---- 数据发送 -----
  if (killPending && resAction) {
    resAction()
  }
  if (actionChange) {
    actionChange(objValue, option)
  }
  // 头部总控
  if (headerchange) {
    headerchange(
      { ...objValue },
      formatClearKey
    )
  }

  if (action) {
    // 清理数据
    formatQuery = omit(formatQuery, formatClearKey)
    // ** -- 兼容 旧版 redux 写法，没有 path参数
    const actions = {
      path: async() => {
        try {
          await action(path, formatQuery)
        } catch (err) {
          console.log('control path', err)
          throw err
        }
      },
      undefined: async() => {
        try {
          await action(formatQuery)
        } catch (err) {
          console.log('default path', err)
          throw err
        }
      }
    }
    actions[requestType]()
    // ** -- 兼容 旧版 redux 写法，没有 path参数

    // return action(formatQuery)
  }
}
